export default __webpack_public_path__ + "static/media/chefartur_thumb.eca35f86.jpg";